import React from 'react'
import { INewsItem } from '../../../app/reducers/news/news.slice'
import title from './../../../assets/img/svg/sairus-white.svg'
import ColoredDate from './Date'
import styles from './News.module.scss'

interface Props extends React.HTMLProps<HTMLDivElement> {
	newsItem: INewsItem
	isOpen: boolean
}

const ImageNewsItem: React.FC<Props> = ({ newsItem, isOpen, onClick }) => {
	return (
		<div className={`${isOpen ? styles.paddingBox : ''}`} onClick={onClick}>
			<div className={styles.box}>
				<ColoredDate date={newsItem.published} />
				<h3 className={`${styles.newsTitle} ${isOpen ? styles.textSmall : ''}`}>
					{newsItem.title}
				</h3>
			</div>
			<div
				className={`${styles.imageNewsItem} ${
					isOpen ? styles.smallImageNewsItem : ''
				}`}
				style={{ backgroundImage: `url('${newsItem.imageUrl}')` }}
			>
				<div className={styles.imageNewsItemTitle}>
					<img className={styles.img_title} src={title} alt='SAIRUS' />
				</div>
				<div className={styles.imageNewsItemBody}></div>
			</div>
		</div>
	)
}

export default ImageNewsItem
